import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from "lodash";
import {withStyles} from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 20px 20px 20px',
		}
	},
	dialogPaper: {
		overflow: 'scroll',
		//width: '98%',
		//maxWidth: '98%',
		//maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	pageImage : {
		width : '100%',
		//height : '100%',
		border : '1px solid #888',
		marginLeft : 10,
	}
});

class InvoiceDocumentPopup extends PureComponent {
	/*
	constructor (props) {
		super(props);
	}
	*/

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const {classes, invoiceDocuments, resourceMap, fullScreen } = this.props;

		if (_.isEmpty(invoiceDocuments)) {
			return null;
		}

		const resources = [];
		invoiceDocuments.forEach(({pageResourceIds}) => {
			pageResourceIds.forEach(pageResourceId => {
				resources.push(resourceMap[pageResourceId]);
			});
		});

		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					fullScreen={fullScreen}
					maxWidth='md'
					classes={{
						paper: classes.dialogPaper
					}}
				>
					<DialogTitle>
						<div style={{alignItems : 'center', display : 'flex', justifyContent: 'space-between'}}>
							<Button onClick={this.handleClose}>Close</Button>
						</div>
					</DialogTitle>
					<DialogContent>
						{resources.map((resource, i) => {
							return (<div key={i}>
								<img alt={`page ${i}`} className={classes.pageImage} src={resource.url} />
							</div>);
						})}
					</DialogContent>

				</Dialog>
			</div>
		);
	}
}

InvoiceDocumentPopup.propTypes = {
	invoiceDocuments : PropTypes.array,
	resourceMap : PropTypes.object,
	open : PropTypes.bool,
	onClose : PropTypes.func,
	fullScreen: PropTypes.bool.isRequired,
	classes : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(InvoiceDocumentPopup);